// MonitorLocationChange.js
import { connect } from 'react-redux';

import sendViewTracking from '../action/sendViewTracking.js';
import pushRouteHistory from '../action/pushRouteHistory.js';
import cancelShopping from '../action/cancelShopping.js';
import getOperationData from '../selector/getOperationData.js';
import MonitorLocationChange from '../component/MonitorLocationChange.jsx';
import getMeData from '../selector/getMeData.js';
import replaceTemplate from '../resource/replaceTemplate.js';
import {
  USER_EVENT_REPORT_URL,
  INTERCOM_UPDATE_DEBOUNCE_MSEC,
} from '../RemoteConfigKeys.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getModalData from '../selector/getModalData.js';
import { addvalue as addvalueModalIds } from '../resource/modalId.js';

const mapStateToProps = (state, { location: { pathname, search } }) => {
  const shopId = getOperationData(state, ['shop'], 'usingShopId');
  const meId = getMeData(state, 'id');
  const userEventReportUrl = replaceTemplate({
    string: getRemoteConfigData(state, USER_EVENT_REPORT_URL),
    data: {
      USER_ID: meId || '',
    },
  });
  return {
    shopId,
    route: `${pathname}${search}`,
    userEventReportUrl,
    timestampOffsetMilliseconds: getTimestampOffset(
      state,
      Accuracy.MILLISECOND
    ),
    intercomUpdateDebounceMsec: getRemoteConfigData(
      state,
      INTERCOM_UPDATE_DEBOUNCE_MSEC
    ),
    isDiamondShopOpen: !!['display', 'opening'].includes(
      getModalData(state, addvalueModalIds.DIAMOND_PACK_SELECTOR, 'status')
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    pushRouteHistory: ({ route }) =>
      dispatch(pushRouteHistory({ href: route })),
    cancelShopping: ({ shopId }) => dispatch(cancelShopping({ shopId })),
    sendViewTracking: payload => dispatch(sendViewTracking(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MonitorLocationChange);
